const logos = [
  '/partners/bakertilly.png',
  '/partners/dochas.png',
  '/partners/ni.png',
  '/partners/revsavvy.png',
  '/partners/cgi.png',
  '/partners/zs.png',
  '/partners/woven.png',
  '/partners/modeln.png',
];

export default logos;
